import React from 'react';
import * as styledComponents from './styles'
import { Row, Col } from 'react-bootstrap';
import { portfolioArray } from './data';

const getPortffolio = () => {
  return (
    portfolioArray.map((portfolioItem) => {
      return (
        <styledComponents.ProjectCard target="_blank" href={portfolioItem.href} rel="noopener noreferrer">
          <styledComponents.CardImage src={portfolioItem.src} alt={portfolioItem.alt} />
          <styledComponents.InfoContainer>
            <styledComponents.TitleCard>{portfolioItem.title}</styledComponents.TitleCard>
            <styledComponents.SubtitleCard>{portfolioItem.subtitle}</styledComponents.SubtitleCard>
          </styledComponents.InfoContainer>
        </styledComponents.ProjectCard>
      )
    })
  )
}
const Home = React.forwardRef((props, ref) => {
  return (
    <styledComponents.PortfolioContainer ref={ref}>
      <Row>
        <Col md>
          <styledComponents.ContainerListDesktop>
            {getPortffolio()}
          </styledComponents.ContainerListDesktop>
        </Col>
        <Col md>
          <styledComponents.HeadTitle>PORTFOLIO</styledComponents.HeadTitle>
          <styledComponents.Title>
            OUR EXPERIENCE TALKS FOR OURSELVES
          </styledComponents.Title>
          <styledComponents.Description>
            From the simplest to the most complex solutions, we are committed to deliver the best quality solutions for our partners.<br /><br />
          We are involved in all of the development cycle and we will ensure that you reach the expected results.
          </styledComponents.Description>
          <styledComponents.ContainerListPhone>
            {getPortffolio()}
          </styledComponents.ContainerListPhone>
          <styledComponents.CallToAction onClick={() => { window.open("https://calendly.com/luisenriquecgongora") }}>FREE 30-MIN CONSULTATION</styledComponents.CallToAction>
        </Col>
      </Row>
    </styledComponents.PortfolioContainer>
  );
});

export default Home;
